// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__VNQuB","errorLabel":"TextInput_errorLabel__3L4j-"};